import putItemDynamoDB from '../../api/putItemDynamoDB';
import { trainSetsTableName } from '../../api/apiConstants';

const putTrainSet = async (myTrainSet: any, myToken: any, myCustomId: any) => {
  const data = await putItemDynamoDB(
    trainSetsTableName,
    myTrainSet,
    myToken,
    myCustomId
  );
  if (data.err) {
    return null;
  }
  return data;
};

export default putTrainSet;
